import type { DropdownMenuItem } from '../components/DropdownMenu';

/** 应用界面语言选项（登录、注册、主页统一） */
export const APP_LANGUAGE_OPTIONS: DropdownMenuItem[] = [
  { id: 'zh-CN', label: '中文简体' },
  { id: 'zh-HK', label: '中文繁体' },
  { id: 'en', label: 'English' }
];

export type AppLanguageCode = 'zh-CN' | 'zh-HK' | 'en';
